import { render, staticRenderFns } from "./NewAccountDropdown.vue?vue&type=template&id=b6b26bc8"
import script from "./NewAccountDropdown.vue?vue&type=script&lang=js"
export * from "./NewAccountDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports